var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config.inline)?_c('div',{staticClass:"datetimepicker-inline"}):_c('input',{staticClass:"form-control",attrs:{"type":"text","disabled":_vm.disabled,"placeholder":_vm.config.format}})
}
var staticRenderFns = []

export { render, staticRenderFns }